import apiClient from "./apiClient";

export const validateAccountRequest = (data) =>
  apiClient({
    method: "POST",
    url: "/billers/account/validate",
    data,
  });
